const { sameWithMultiPath } = require('../utils');
const { DEFAULT_TEXT_BODY_STYLE } = require('../../Shape/AbstractShape/config/defaultStyles');

exports.computeAutoFitShapeFromTextBodies = textBodies => sameWithMultiPath(textBodies, ['autoFitShape', 'assignedStyles.textBody.autoFitShape'], DEFAULT_TEXT_BODY_STYLE.autoFitShape, { skipUndefined: false });
